// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconFilledMore = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.813 14.207a2.188 2.188 0 100-4.375 2.188 2.188 0 000 4.375zm14.375 0a2.188 2.188 0 100-4.375 2.188 2.188 0 000 4.375zm-5-2.188a2.188 2.188 0 11-4.376 0 2.188 2.188 0 014.376 0z"
      fill="currentColor"
    />
  );
export default SvgIconFilledMore;
